import { inject, Injectable } from '@angular/core';
import { User } from '@angular/fire/auth';
import { Firestore, doc, getDoc, setDoc } from '@angular/fire/firestore';
import { FSUser } from '../model/firestore-model';
import { from, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private firestore = inject(Firestore);

  getUser(uid: string) {
    return from(getDoc(doc(this.firestore, `users/${uid}`))).pipe(
      map(snap => snap.exists() ? snap.data() as FSUser : null)
    );
  }

  async updateUser(user: User) {
    const fsUser: FSUser = JSON.parse(
      JSON.stringify({
        displayName: user.displayName,
        email: user.email,
        emailVerified: user.emailVerified,
        isAnonymous: user.isAnonymous,
        metadata: user.metadata,
        phoneNumber: user.phoneNumber,
        photoURL: user.photoURL,
        uid: user.uid,
      })
    );

    await setDoc(doc(this.firestore, `users/${user.uid}`), fsUser, {
      merge: true,
    });
  }
}
